import moment from 'moment'
import TRANSLATE, { REGEXP, INTERNAL_DOMAINS, PROVIDER_PC_ID, RESTRICTED_EMAIL_DOMAINS } from './constants'

class Utils {
   noMoreThanNCharacters = n => {
      return TRANSLATE.FORM.NO_MORE_THAN_N_CHARACTERS.replace('%n%', n)
   }

   minimumNCharacters = n => {
      return TRANSLATE.FORM.MINIMUM_N_CHARACTERS.replace('%n%', n)
   }

   convertInputValueToUpperCase = callback => event => {
      const { target = {} } = event
      target.value = target.value.toUpperCase()
      callback(event)
   }

   getNoSpaceTitle = title => title.replace(/\s/g, '')

   validateAndPassToLowerCase = (regex, cb) => e => {
      const event = { ...e }
      if (new RegExp(regex).test(event.target.value)) {
         event.target.value = event.target.value.toLowerCase()
         cb(event)
      }
   }

   validateAndPassToUpperCase = (regex, cb) => e => {
      const event = { ...e }
      if (new RegExp(regex).test(event.target.value)) {
         event.target.value = event.target.value.toUpperCase()
         cb(event)
      }
   }

   normalize = (str, type = 'NFD') => {
      return str.normalize(type).replace(/[\u0300-\u036f]/g, '')
   }

   buildUrlFromText = str => {
      return this.normalize(str).replace(/\s/g, '-')
   }

   validatePath = url => {
      return url.startsWith('/') ? url : `/${url}`
   }

   capitalizeFirstLetter = string => {
      return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
   }

   /*
        @PARAM {Array} obj - Array Object to filter
        @PARAM {String} prop - Name param to filter Array Object
    */
   sortObjectByPropName = (obj, prop) => {
      return obj.sort((a, b) => (a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0))
   }

   /*
        @PARAM {Object} jsonResponse - JSON response to download
        @PARAM {String} fileName - Name to download file
    */
   downloadJSON = async (jsonResponse, fileName = `export_${Date.now()}`) => {
      const json = JSON.stringify(jsonResponse)
      const blob = new Blob([json], { type: 'application/json' })
      const href = await URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
   }

   sortItemsByDate(left, right) {
      return moment(`${right.createdDate} ${right.hour}`, 'DD-MM-YYYY hh:mm:ss').diff(
         moment(`${left.createdDate} ${left.hour}`, 'DD-MM-YYYY hh:mm:ss')
      )
   }

   saveByteArray(fileName, fileType, bytes) {
      const fileBlob = new Blob([bytes], { type: fileType })
      const blobUrl = window.URL.createObjectURL(fileBlob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', fileName)
      link.click()
      link.remove()
      URL.revokeObjectURL(blobUrl)
   }
}

export default new Utils()

class FormUtils {
   getFieldLabel = (isSearch, label) => `${label} ${isSearch ? '' : '*'}`
   notRequired = value => !value || value === ''
   lengthHigherThan = (value, limitOfchar) => value.length > limitOfchar
   doesNotMatchRegexp = (value, regexp) => !regexp.exec(value)
   notEmpty = value => !value?.length
}

export const formUtils = new FormUtils()

export const reactSwitch = (key, options) => options[key] || options?.default

export const validateDocumentNumber = (idType, idNumber) =>
   reactSwitch(idType, {
      9: REGEXP.CEDULA_CIUDADANIA_REGEX.test(idNumber),
      10: REGEXP.CEDULA_EXTRANJERIA_REGEX.test(idNumber),
      11: REGEXP.PERMISO_ESPECIAL_PERMANENCIA_REGEX.test(idNumber),
      12: REGEXP.NIT_REGEX.test(idNumber),
      CC: REGEXP.CEDULA_CIUDADANIA_REGEX.test(idNumber),
      TI: REGEXP.TARJETA_IDENTIDAD_REGEX.test(idNumber),
      NI: REGEXP.NIT_REGEX.test(idNumber),
      CD: REGEXP.CARNE_DIPLOMATICO_REGEX.test(idNumber),
      CE: REGEXP.CEDULA_EXTRANJERIA_REGEX.test(idNumber),
      PA: REGEXP.PASAPORTE_REGEX.test(idNumber),
      PE: REGEXP.PERMISO_ESPECIAL_PERMANENCIA_REGEX.test(idNumber),
      SC: REGEXP.SALVOCONDUCTO_PERMANENCIA_REGEX.test(idNumber),
      PT: REGEXP.PERMISO_PROTECCION_TEMPORAL_REGEX.test(idNumber),
      PC: REGEXP.PERMISO_ESPECIAL_PERMANENCIA_TUTORES_REGEX.test(idNumber),
      ...(PROVIDER_PC_ID && { [PROVIDER_PC_ID]: REGEXP.PERMISO_ESPECIAL_PERMANENCIA_TUTORES_REGEX.test(idNumber) }),
      default: false
   })

export const userSettingsModule = {
   obtenerUserSettings() {
      const userSettingsString = localStorage.getItem('user_settings')
      if (userSettingsString) {
         try {
            return JSON.parse(userSettingsString)
         } catch (error) {
            console.error('Error al analizar el JSON:', error)
         }
      }
      return null
   },

   buscarValorEnUserSettings(clave, valorBuscado) {
      const userSettings = this.obtenerUserSettings()
      if (userSettings?.hasOwnProperty(clave)) {
         const operation = userSettings[clave]
         return buscarValorEnObjetoAnidado(operation, valorBuscado)
      }
      return false
   },
   isInternalUser() {
      return this.obtenerUserSettings()?.type === 'I'
   }
}
function buscarValorEnObjetoAnidado(objeto, valorBuscado) {
   for (const clave in objeto) {
      if (typeof objeto[clave] === 'object') {
         if (buscarValorEnObjetoAnidado(objeto[clave], valorBuscado)) {
            return true
         }
      } else if (removeAccents(objeto[clave])?.toLowerCase() === removeAccents(valorBuscado)?.toLowerCase()) {
         return true
      }
   }
   return false
}

// Funcion para quitar los acentos:
function removeAccents(str) {
   return str?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '')
}

export function formatInitialDateQuestionnaire(input) {
   if (!input) return
   let parts = input.split(' ')
   let datePart = parts[0].split('-')
   let timePart = parts[1].split(':')

   let date = new Date(datePart[2], datePart[1] - 1, datePart[0], timePart[0], timePart[1])

   let formattedDate =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0') +
      'T' +
      date.getHours().toString().padStart(2, '0') +
      ':' +
      date.getMinutes().toString().padStart(2, '0')

   return formattedDate
}

export function formatFinalDateQuestionnaire(input) {
   if (!input) return
   let parts = input.split('-')
   let formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0]
   return formattedDate
}

export const isInternalEmail = email => {
   return INTERNAL_DOMAINS.some(domain => email.toLowerCase().endsWith(domain.toLowerCase()))
}

export const isRestrictedEmail = email => {
   return RESTRICTED_EMAIL_DOMAINS.some(domain => email.toLowerCase().endsWith(domain.toLowerCase())
   )
}
